import React from 'react';
import { Card, Tag, Divider, Space, Typography } from 'antd';

const { Text } = Typography;

const stageKindColor: Record<string, string> = {
  REVIEW: 'warning',
  INPUT: 'blue',
  TASK: 'success',
};

interface WorkflowDiagramProps {
  flow: any;
}

const WorkflowDiagram = ({ flow }: WorkflowDiagramProps) => {
  if (!flow) {
    return <div>No workflow selected</div>;
  }

  const stages = flow.stages || [];

  return (
    <div>
      <Card style={{ marginBottom: 16 }}>
        <Space direction="vertical" size="small">
          <Text strong>{flow.name}</Text>
          {flow.tags?.length > 0 && (
            <Space>
              {flow.tags.map((tag: string, i: number) => (
                <Tag key={i} color="blue">{tag}</Tag>
              ))}
            </Space>
          )}
          {flow.type && <Tag color="geekblue">{flow.type}</Tag>}
          {flow.description && <Text>{flow.description}</Text>}
        </Space>
      </Card>
      <Divider />
      {stages.map((stage: any, index: number) => (
        <div key={stage.key || index} style={{ marginBottom: 16 }}>
          <Card style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
              <Space>
                <Text style={{ fontWeight: 600 }}>
                  {index + 1}. {stage.key}
                </Text>
                <Tag color={stageKindColor[stage.kind] || 'default'}>{stage.kind}</Tag>
              </Space>

              <div>
                <Text strong>Assignment:</Text>
                <Tag color="purple" style={{ marginLeft: 8 }}>{stage.assignmentStrategy}</Tag>
              </div>

              {stage.assignees?.length > 0 && (
                <div>
                  <Text strong>Assignees:</Text>
                  <Space wrap style={{ marginLeft: 8 }}>
                    {stage.assignees.map((a: any, i: number) => (
                      <Tag key={i} color="cyan">
                        {a.actorName || a.actorId} ({a.actorType}, {a.source})
                      </Tag>
                    ))}
                  </Space>
                </div>
              )}

              {stage.actions?.length > 0 && (
                <div>
                  <Text strong>Actions:</Text>
                  <Space wrap style={{ marginLeft: 8 }}>
                    {stage.actions.map((action: any, i: number) => (
                      <Tag key={i} color={action.result === 'BACK' ? 'red' : 'green'}>
                        {action.label} → {action.result}
                      </Tag>
                    ))}
                  </Space>
                </div>
              )}

              {stage.customFields?.length > 0 && (
                <div>
                  <Text strong>Custom Fields:</Text>
                  <Space wrap style={{ marginLeft: 8 }}>
                    {stage.customFields.map((f: any, i: number) => (
                      <Tag key={i} color="orange">{f.label} ({f.fieldType}){f.required ? ' *' : ''}</Tag>
                    ))}
                  </Space>
                </div>
              )}

              {stage.instructions && (
                <div>
                  <Text strong>Instructions:</Text>
                  <Text style={{ marginLeft: 8 }}>{stage.instructions}</Text>
                </div>
              )}
            </Space>
          </Card>
          {index < stages.length - 1 && (
            <div style={{ textAlign: 'center', fontSize: 24, marginTop: 8 }}>↓</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default WorkflowDiagram;